import {PropsWithChildren} from "react";
import {FiLoader} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {DownloadCheckReport} from "@/pages/checks/analysis/actions/DownloadCheckReport.tsx";
import {ExploreMetricsButton} from "@/pages/checks/analysis/actions/ExploreMetricsButton.tsx";
import {ShareReport} from "@/pages/checks/analysis/actions/ShareReport.tsx";

interface CheckDetailsActionsProps extends PropsWithChildren {
  publicURL?: string;
  id: number;
  // Present only for NETWORK checks — adds a "Run Test" action alongside the others.
  networkRunTest?: {onRun: () => void; running: boolean; ready: boolean};
  checkType: string;
}

export const CheckDetailsActions = ({id, publicURL, children, networkRunTest, checkType}: CheckDetailsActionsProps) => {
  const {brand} = useCurrentUserContext();

  return (
    <div className="d-flex gap-3 align-items-center">
      {children}
      {networkRunTest && (
        <Button
          variant="secondary"
          size="large"
          onClick={networkRunTest.onRun}
          disabled={networkRunTest.running || !networkRunTest.ready}
          className="text-nowrap"
        >
          {networkRunTest.running && <Icon icon={FiLoader} className="pulseSpin me-2" />}
          Run Test
        </Button>
      )}
      {publicURL && <ShareReport url={publicURL} btnText="Share Report" />}
      <ExploreMetricsButton checkId={id} checkType={checkType} />
      <DownloadCheckReport id={id} brand={brand} />
    </div>
  );
};
